import WebsiteBehaviors from "../website-behaviors/index.js";

class OJS extends WebsiteBehaviors {
	identifier() {
		return "OJS";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
		const meta_generator = window.top.document.querySelector("meta[name='generator']");

		if (!meta_generator)
			return false;

		return (meta_generator as any).content.startsWith("Open Journal Systems");
	}

	shouldFrameTakeControl() {
		if ((window.frameElement as any).title.includes("PDF of"))
			return true;

		if ((window.frameElement as any).name !== "htmlFrame")
			return false;

		// Check if the iframe src is the same as the page url
		return (window.frameElement as any).src === window.location.href;
	}

	isPDF() {
		return (window.frameElement as any).title.includes("PDF of");
	}
}

export default OJS;
